"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var useKeyPressClose = function useKeyPressClose(closeCallback) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 27;

  function handleClose(_ref) {
    var keyCode = _ref.keyCode;

    if (keyCode === key) {
      closeCallback(false);
    }
  }

  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleClose, false);
    return function () {
      document.removeEventListener('keydown', handleClose, false);
    };
  }, []);
};

var _default = useKeyPressClose;
exports["default"] = _default;